export default __webpack_public_path__ + "static/media/Chicken Nuggets - proportioned_170.807fd845.jpg";